import { render, staticRenderFns } from "./balanceRechargeRecordVip.vue?vue&type=template&id=1999c87d&scoped=true&"
import script from "./balanceRechargeRecordVip.vue?vue&type=script&lang=js&"
export * from "./balanceRechargeRecordVip.vue?vue&type=script&lang=js&"
import style0 from "./balanceRechargeRecordVip.vue?vue&type=style&index=0&id=1999c87d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1999c87d",
  null
  
)

export default component.exports